export const ROWS_PER_PAGE = [100, 25, 10] as const;
